/**
 * Map-related hooks
 *
 * Hooks for managing map state, positioning, history sync, and map interactions.
 */

export { isLiveMapPosition } from './mapStateKeys';
export { useBorderToggle } from './useBorderToggle';
export { useDetectedAreaUrlSync } from './useDetectedAreaUrlSync';
export { useDynamicAreaDetection } from './useDynamicAreaDetection';
export { useMapBounds, useGoogleMapsKey } from './useMapData';
export { useGoogleMapsLoaded, useGoogleMapsLoadFailed } from './useGoogleMapsLoaded';
export {
  useMapHistorySync,
  skipNextIdleUpdate,
  suppressNextUrlUpdate,
  isHistoryRestoreInFlight,
  clearHistoryRestoreInFlight,
} from './useMapHistorySync';
export { useMapInitialPosition } from './useMapInitialPosition';
export {
  useActiveListing,
  useClearPendingMapAreaNavigation,
  usePrepareMapForAreaNavigation,
  usePrepareMapForListingNavigation,
  useSetActiveListing,
  useMapPosition,
  useSetMapPosition,
  useMapMarkers,
  useSetMapMarkers,
  useMapBorderState,
  useSetMapBorderState,
  useMapDetectedArea,
  useSetMapDetectedArea,
  useNearMeMapContext,
  useSetNearMeMapContext,
  usePendingMapAreaNavigation,
  useMapPinnedMarker,
  useSetMapPinnedMarker,
  useMapHoveredMarker,
  useSetMapHoveredMarker,
  mapStateKeys,
} from './useMapState';
